import { render, staticRenderFns } from "./MultipleViewItem.vue?vue&type=template&id=724610bf&"
import script from "./MultipleViewItem.vue?vue&type=script&lang=js&"
export * from "./MultipleViewItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports